module.exports = __webpack_public_path__ + "static/media/Battle Bands.1798988b.png";